/* tslint:disable */

/**
 */
export class ConsumptionPieParam {
    percentProduct?: number;
    percentEquipmentPerm?: number;
    percentEquipmentDown?: number;
    percentLine?: number;
    percentProductLabel?: string;
    percentEquipmentPermLabel?: string;
    percentEquipmentDownLabel?: string;
    percentLineLabel?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/consumption-pie-param.ts